/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react'
import { scaleLinear } from 'd3'

const timeScale = scaleLinear().domain([0, 1]).range([0, 2.5]).clamp(true)

type ScrubProps = {
    $video: HTMLVideoElement
}

export default function Scrub({ $video }: ScrubProps) {
    const [xPos, setXPos] = useState(0)
    const isDragging = useRef(false)
    const $timeline = useRef<HTMLDivElement>(null)
    const startX = useRef(0)
    const timelineWidth = useRef(1)
    const lastTime = useRef(Number.MIN_SAFE_INTEGER)

    function clearPointerUp() {
        isDragging.current = false

        window.removeEventListener('pointerup', clearPointerUp)
    }

    function handlePointerDown() {
        if (!$timeline.current) {
            return
        }

        timelineWidth.current = $timeline.current.offsetWidth
        startX.current = $timeline.current.getBoundingClientRect().left
        isDragging.current = true

        // Auto removes listener
        window.addEventListener('pointerup', clearPointerUp)
    }

    function handlePointerMove(e: MouseEvent) {
        if (isDragging.current) {
            const diff = Math.max(
                0,
                Math.min(e.clientX - startX.current, timelineWidth.current)
            )
            setXPos(diff)

            if (!$video.seeking) {
                requestAnimationFrame(() => {
                    if (isDragging.current) {
                        const percent = diff / timelineWidth.current
                        const time = timeScale(percent)
                        $video.currentTime = time
                    }
                })
            }
        }
    }

    function handleTimelineClick(e: React.MouseEvent) {
        if (!$timeline.current) {
            return
        }

        startX.current = $timeline.current.getBoundingClientRect().left

        const diff = Math.max(
            0,
            Math.min(e.clientX - startX.current, timelineWidth.current)
        )
        setXPos(diff)

        const percent = diff / timelineWidth.current
        const time = timeScale(percent)
        $video.currentTime = time
    }

    function handleTimeUpdate() {
        if (!$timeline.current) {
            return
        }

        if (lastTime.current === $video.currentTime) {
            return
        }

        lastTime.current = $video.currentTime

        const percent = timeScale.invert($video.currentTime)
        timelineWidth.current = $timeline.current.offsetWidth
        const pixels = timelineWidth.current * percent

        setXPos(pixels)
    }

    useEffect(() => {
        window.addEventListener('pointermove', handlePointerMove)
        $video.addEventListener('timeupdate', handleTimeUpdate)

        return () => {
            window.removeEventListener('pointermove', handlePointerMove)
            $video.addEventListener('timeupdate', handleTimeUpdate)
        }
    })

    return (
        <div id="scrub-timeline">
            <div
                ref={$timeline}
                id="scrub-progress-timeline"
                onClick={handleTimelineClick}
            />
            <div
                id="scrub-progress-handle"
                onPointerDown={handlePointerDown}
                style={{ transform: `translate(${xPos}px, 0)` }}
            />
        </div>
    )
}
